<template>
  <div>
    <el-row class="top" type="flex">
      <el-col :span="2">
        固件基本信息
      </el-col>
      <el-col >
        <span @click="edit" class="edit">
          <i class="el-icon-edit"></i>
          编辑
        </span>
      </el-col>
    </el-row>
    <!-- table -->
    <el-row type="flex" class="tables">
      <el-col :span="index > 8 ? 24: 8" v-for="(item,index) in listData" :key="index">
        <el-col :span="index > 8 ? 2: 6">{{item.name}}</el-col>
        <el-col :span="index > 8 ? 22: 18">
          <span class="tip" v-if="item.name==='固件状态'" :style="{background:(firmwareData.verifyStatus === 1 ? 'green': '#888')}"></span>
          {{item.value}}
          <span class="copy" v-if="item.name==='固件版本号'||item.name==='待升级版本号'||item.name==='升级后版本号'" @click="copy(item.name)">
            复制
          </span>
          <span class="refresh" v-if="item.name === '验证进度'&& firmwareData.verifyStatus === 0" @click="refresh">
            刷新
          </span>
        </el-col>
      </el-col>
    </el-row>
    <!-- 固件检测服务 -->
    <el-row style="margin-bottom:20px">
      固件检测服务
    </el-row>
    <el-row class="test">
      <el-col :span="12">
        <el-col :span="5">检测状态</el-col>
        <el-col :span="19">
          <span class="tip"></span>
          检测中
        </el-col>
      </el-col>
      <el-col :span="12">
        <el-col :span="5">安全风险数量</el-col>
        <el-col :span="19">-</el-col>
      </el-col>
    </el-row>
    <!-- dialog -->
    <!-- 新增固件Dialog -->
      <el-dialog  :close-on-click-modal="false" title="编辑固件" :visible.sync="dialogFormVisible" width="30%" :append-to-body="true">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
          <el-form-item label="固件名称" prop="firmwareName" >
            <el-input v-model.trim="ruleForm.firmwareName"  placeholder="请输入固件名称"> </el-input>
          </el-form-item>
          <el-form-item label="固件版本号"  :required="true" v-if="this.firmwareData.firmwareType === 0">
            <el-input v-model.trim="ruleForm.destVersion" placeholder="请输入固件版本号" :disabled="true"></el-input>
          </el-form-item>
          <!-- 选择差分的时候显示下面两个 -->
          <el-form-item label="待升级版本号" :required="true" v-if="this.firmwareData.firmwareType === 1">
            <el-input v-model="ruleForm.sourceVersion" placeholder="请输入或选择升级版本号" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="升级后版本号" :required="true" v-if="this.firmwareData.firmwareType === 1">
            <el-input v-model="ruleForm.destVersion" placeholder="版本号需与实际固件版本号保持一致"  :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="所属产品"  :required="true" >
            <el-select
              disabled
              filterable
              allow-create
              default-first-option
              v-model="ruleForm.productName"
              placeholder="请选择固件所属产品"
              style="width:100%">
              <el-option label="智能设备" value="智能设备"></el-option>
              <el-option label="普通设备" value="普通设备"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签名算法"  :required="true" >
            <el-select v-model="ruleForm.signMethod" style="width:100%" disabled >
              <el-option label="Md5" value="Md5"></el-option>
              <!-- <el-option label="Sha256" value="sha256"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="固件描述" prop="firmwareDesc">
            <el-input type="textarea" v-model="ruleForm.firmwareDesc" :rows="3" maxlength="100" show-word-limit></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">修改</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
  </div>
</template>
<script>
import { firmwareInfo, firmwareInfoEdit, progressStatus } from '@/api/productControl.js'
export default {
  props: {
    firmwareData: {
      type: Object,
      default: function () {
        return ''
      }
    }
  },
  data () {
    return {
      listData: [],
      firmwareInfoList: [],
      dialogFormVisible: false,
      ruleForm: {
        firmwareName: this.firmwareData.firmwareName, // 固件名称
        destVersion: this.firmwareData.destVersion, // 固件版本号及升级后版本号
        sourceVersion: this.firmwareData.sourceVersion, // 待升级版本
        productName: this.firmwareData.productName, // 产品名 TODO: 需要做接口调用拿值
        signMethod: this.firmwareData.signMethod, // 签名算法
        firmwareDesc: this.firmwareData.firmwareDesc
      },
      rules: {
        firmwareName: [
          { required: true, message: '请输入固件名称', trigger: 'blur' }
        ]
      },
      progressStatus: ''
    }
  },
  created () {
    this.getProgressStatus()
  },
  methods: {
    getProgressStatus () {
      const params = {
        params: {
          firmwareId: this.firmwareData.firmwareId
        }
      }
      progressStatus(params).then(res => {
        if (res.data.code === 200) {
          this.progressStatus = res.data.data.upgradeStep
          this.getfirmwareInfo()
        }
      })
    },
    getfirmwareInfo () {
      const params = {
        params: {
          firmwareId: this.firmwareData.firmwareId
        }
      }
      firmwareInfo(params).then((res) => {
        console.log('get=============', res.data.data)
        this.firmwareInfoList = res.data.data
        this.listData = [
          { name: '固件ID', value: this.firmwareInfoList.firmwareId },
          { name: '固件名称', value: this.firmwareInfoList.firmwareName },
          { name: '所属产品', value: this.firmwareInfoList.productName },
          { name: '固件签名', value: this.firmwareInfoList.firmwareSign },
          { name: '固件版本号', value: this.firmwareInfoList.destVersion },
          { name: '添加时间', value: this.firmwareInfoList.createTime },
          { name: '签名算法', value: this.firmwareInfoList.signMethod },
          { name: '固件状态', value: this.firmwareInfoList.verifyStatus === 1 ? '已验证' : '未验证' },
          { name: '验证进度', value: this.firmwareInfoList.verifyStatus === 1 ? '100%' : this.progressStatus + '%' },
          { name: '固件描述', value: this.firmwareInfoList.firmwareDesc === null || this.firmwareInfoList.firmwareDesc === '' ? '-' : this.firmwareInfoList.firmwareDesc }
        ]
        if (this.firmwareInfoList.firmwareType === 1) { // 差包
          this.listData.splice(4, 1, { name: '待升级版本号', value: this.firmwareInfoList.sourceVersion }, { name: '升级后版本号', value: this.firmwareInfoList.destVersion })
        }
      })
    },
    // 重新加载
    reLoad () {
      window.location.reload()
    },
    edit () {
      this.dialogFormVisible = true
    },
    copy (val) {
      const input = document.createElement('input') // 直接构建input
      if (val === '固件版本号' || val === '升级后版本号') {
        input.value = this.firmwareData.destVersion
      }
      if (val === '待升级版本号') {
        input.value = this.firmwareData.sourceVersion
      }
      document.body.appendChild(input) // 添加临时实例
      input.select() // 选择实例内容
      document.execCommand('Copy') // 执行复制
      document.body.removeChild(input) // 删除临时实例
      this.$message({
        type: 'success',
        message: '复制成功'
      })
    },
    refresh () {
      this.getProgressStatus()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) { // 验证成功
          const params = {
            params: {
              firmwareId: this.firmwareData.firmwareId,
              firmwareName: this.ruleForm.firmwareName,
              firmwareDesc: this.ruleForm.firmwareDesc
            }
          }
          firmwareInfoEdit(params).then(() => {
            this.$message({
              message: '编辑成功',
              type: 'success'
            })
          })
          this.$emit('getfirmwareName', this.ruleForm.firmwareName)
          this.getfirmwareInfo()
          this.dialogFormVisible = false
          this.refresh()
        } else {
          this.$message.error('请完善信息后再试')
        }
      })
    },
    // 重置
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang='less' scoped>
  .top{
    margin-bottom: 15px;
    font-weight: bold;
    .edit{
      font-weight: normal;
      color: deepskyblue;
    }
    .edit:hover{
      cursor: pointer;
    }
  }
  .tables{
    flex-wrap: wrap;
    border-bottom: 1px solid  #ecedee;
    border-right: 1px solid  #ecedee;
    margin-bottom: 20px;
    .el-col-8, .el-col-24{
      border-top: 1px solid  #ecedee;
       .el-col-6,.el-col-2{
        border-right: 1px solid  #ecedee;
        border-left: 1px solid  #ecedee;
        background-color: #fbfbfc;
        color: #73777a;
        padding: 14px 12px;
      }
      .el-col-18,.el-col-22{
        color: #373d41;
        padding: 14px 12px;
        .tip{
          height: 8px;
          width: 8px;
          border-radius: 50%;
          background: #888;
          display: inline-block;
          margin-right: 8px;
        }
        .copy, .refresh{
          color: deepskyblue;
          margin-left: 8px;
        }
        .copy:hover, .refresh:hover{
          cursor: pointer;
        }
      }
    }
  }
  .test{
    .tip{
        height: 8px;
        width: 8px;
        border-radius: 50%;
        background: #0070cc;
        display: inline-block;
        margin-right: 8px;
      }
  }
  /deep/ .el-input__count{
    background: transparent;
    right: 20px;
  }
</style>
